import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { ServiceHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/ServiceHubFaqs';
import { ServiceHubProductIcon } from 'pricing-pages-ui-components/productIcon/ServiceHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { ServiceHubFeatureTable } from './ServiceHubFeatureTable';
import { ServiceHubMerchCards } from './ServiceHubMerchCards';
import { SCREENS } from '../../constants/tracking/Screens';
import PhoneSupportMiddle from '../../components/phone-support/PhoneSupportMiddle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SERVICE_HUB_API_NAMES = [Products.SERVICE_HUB_STARTER, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE];
export const ServiceHubPage = () => {
  const screen = SCREENS.SERVICE;
  useDocumentTitle(screen);
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "SERVICE_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SERVICE",
      apiNames: SERVICE_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(ServiceHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.service.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.service.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ServiceHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "service"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ServiceHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
      phoneSourceId: "service-middle",
      screen: screen,
      apiName: Products.SERVICE_HUB_STARTER
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "service"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ServiceHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "service-footer",
      screen: screen,
      apiName: Products.SERVICE_HUB_STARTER
    })]
  });
};